module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/ahand7-11576f9b29f964fa9aecfbf5ba7fbaaa.jpg";